import React from 'react';
import Backend from '../../../../Layouts/Backend';
import { Form, FormGroup, Label, FormFeedback, CustomInput } from 'reactstrap';
import zxcvbn from 'zxcvbn';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { withTranslation } from 'react-i18next';
import { Formik } from 'formik';
import { validationSchema } from './validation';
import Required from '../../../../UI/Required';
import { remove } from 'lodash';
import { escalationLevelOptions, workDays, active } from '../constant';
import { Dropdown, Input, Alert, Button } from '../../../../UI/Common';
import PasswordConfirmation from '../../../../UI/PasswordConfirmation';
import helper from '../../../../../utils/helper';
import ReactSelect from '../../../../UI/ReactSelect';

const EditUserPage = (props) => {
  //prettier-ignore
  const { t, user = {}, getUserError, isSubmitting, departments, roles, groups } = props;
  const [openModal, setOpenModal] = React.useState(false);
  const [isUsernameChanged, setUsernameChanged] = React.useState(false);
  // const roleNames =
  //   JSON.parse(localStorage.getItem('userProfile')).roleNames || [];
  // const isAdmin = roleNames.includes('admin') || roleNames.includes('Admin');
  let timeFormat = 'HH:mm';
  if (props.i18n.language === 'en_US') {
    timeFormat = 'h:mm aa';
  }
  const getPasswordStrength = (password) => {
    return zxcvbn(password).score;
  };
  const selectWorkDay = (e, day, workDays, setFieldValue) => {
    if (e.target.checked) {
      workDays.push(day);
    } else {
      remove(workDays, (workday) => workday === day);
    }
    setFieldValue(workDays);
  };

  const selectGroup = (e, group, groupIdArray, setFieldValue) => {
    if (e.target.checked) {
      if (!groupIdArray.find((groupId) => groupId === group.id)) {
        groupIdArray.push(group.id);
        setFieldValue('groupIdArray', groupIdArray);
      }
    } else {
      if (groupIdArray.find((groupId) => groupId === group.id)) {
        remove(groupIdArray, (groupId) => groupId === group.id);
        setFieldValue('groupIdArray', groupIdArray);
      }
    }
  };
  if (Object.keys(getUserError).length) {
    return (
      <Backend>
        <div className="content-inner">
          <h1>{t('This group is unavailable')}</h1>
        </div>
      </Backend>
    );
  }
  const isRequireConfirmation = helper.isRequireConfirmation();
  function onSubmit(values) {
    if (isRequireConfirmation) {
      setOpenModal(true);
    } else {
      props.onEditUser(values);
    }
  }
  function onChangeUsername(e, setFieldValue) {
    const currentEmail = e.target.value;
    setFieldValue('userName', currentEmail);
    if (props.originalUsername !== currentEmail) {
      setUsernameChanged(true);
    } else {
      setUsernameChanged(false);
    }
  }
  return (
    <Backend title={`Edit User: ${user.email || ''}`}>
      <div className="content-inner">
        <Formik
          enableReinitialize={!Object.keys(user).length}
          initialValues={user}
          validationSchema={validationSchema(isUsernameChanged)}
          onSubmit={(values) => onSubmit(values)}
        >
          {({
            values,
            handleChange,
            errors,
            setFieldValue,
            setFieldTouched,
            touched,
            handleSubmit,
          }) => {
            return (
              <Form>
                <PasswordConfirmation
                  isOpen={openModal}
                  onCancel={() => setOpenModal(false)}
                  onConfirm={() => {
                    setOpenModal(false);
                    props.onEditUser(values);
                  }}
                />
                <div className="row" style={{ marginBottom: 15 }}>
                  <div className="col">
                    <Input
                      required
                      readOnly={values.name}
                      id="name"
                      label="First Name"
                      onChange={handleChange('name')}
                      value={values.name}
                      invalid={errors.name && touched.name}
                      error={errors.name}
                    />
                    <Input
                      required
                      readOnly={values.surname}
                      id="surname"
                      label="Last Name"
                      onChange={handleChange('surname')}
                      value={values.surname}
                      invalid={errors.surname && touched.surname}
                      error={errors.surname}
                    />
                    <Input
                      id="title"
                      label="Title"
                      onChange={handleChange('title')}
                      value={values.title}
                      invalid={errors.title && touched.title}
                      error={errors.title}
                    />
                    <Dropdown
                      type="dynamic"
                      required
                      translated
                      includeZero
                      label="Escalation Level"
                      data={escalationLevelOptions}
                      value={values.escalationLevel}
                      onChange={({ value }) => {
                        setFieldTouched('escalationLevel', false);
                        setFieldValue('escalationLevel', value);
                      }}
                      valueKey="value"
                      nameKey="label"
                      invalid={touched.escalationLevel}
                      error={errors.escalationLevel}
                    />
                    <Input
                      required
                      id="userName"
                      label="Username"
                      onChange={(e) => onChangeUsername(e, setFieldValue)}
                      value={values.userName}
                      invalid={errors.userName && touched.userName}
                      error={errors.userName}
                    />
                    <FormGroup>
                      <Label>
                        {t('Work Days')} <Required />
                      </Label>
                      {workDays.map((workDay, index) => (
                        <CustomInput
                          key={index}
                          type="checkbox"
                          id={workDay.label}
                          checked={
                            values.workDaysOfWeek
                              ? values.workDaysOfWeek.includes(workDay.value)
                              : false
                          }
                          label={workDay.label}
                          onChange={(e) =>
                            //prettier-ignore
                            selectWorkDay(e, workDay.value, values.workDaysOfWeek, setFieldValue)
                          }
                          inline
                        />
                      ))}
                    </FormGroup>
                    <Dropdown
                      type="dynamic"
                      label="Active"
                      data={active}
                      value={values.active}
                      onChange={({ value }) => {
                        setFieldValue('active', value);
                      }}
                      valueKey="value"
                      nameKey="label"
                    />
                    <FormGroup>
                      <Label htmlFor="startWork">
                        {t('Start Work')} <Required />
                      </Label>
                      <DatePicker
                        id="startWork"
                        className="form-control"
                        selected={values.startWork}
                        onChange={(date) => setFieldValue('startWork', date)}
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={15}
                        timeCaption="Time"
                        timeFormat={timeFormat}
                        dateFormat={timeFormat}
                      />
                      {errors.startWork && touched.startWork && (
                        <FormFeedback>{t(errors.startWork)}</FormFeedback>
                      )}
                    </FormGroup>
                    <FormGroup>
                      <Label htmlFor="endWork">
                        {t('End Work')} <Required />
                      </Label>
                      <DatePicker
                        id="endWork"
                        className="form-control"
                        selected={values.endWork}
                        onChange={(date) => setFieldValue('endWork', date)}
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={15}
                        timeCaption="Time"
                        timeFormat={timeFormat}
                        dateFormat={timeFormat}
                      />
                      {errors.endWork && touched.endWork && (
                        <FormFeedback>{t(errors.endWork)}</FormFeedback>
                      )}
                    </FormGroup>
                    <Input
                      id="workContact"
                      label="Work Contact"
                      onChange={handleChange('workContact')}
                      value={values.workContact}
                      invalid={errors.workContact && touched.workContact}
                      error={errors.workContact}
                    />
                    <Input
                      id="nonWorkContact"
                      label="Non Work Contact"
                      onChange={handleChange('nonWorkContact')}
                      value={values.nonWorkContact}
                      invalid={errors.nonWorkContact && touched.nonWorkContact}
                      error={errors.nonWorkContact}
                    />
                    <Input
                      required
                      readOnly={values.initials}
                      id="initials"
                      label="Initials"
                      onChange={handleChange('initials')}
                      value={values.initials}
                      invalid={errors.initials && touched.initials}
                      error={errors.initials}
                    />
                    <ReactSelect
                      required
                      isClearable={false}
                      label="Department"
                      options={departments}
                      value={values.departmentId}
                      onChange={({ value }) => {
                        setFieldValue('departmentId', value);
                      }}
                      valueKey="id"
                      labelKey="name"
                      invalid={errors.departmentId && touched.departmentId}
                      error={errors.departmentId}
                    />
                    {/* <Dropdown
                      required
                      type="dynamic"
                      includeZero
                      label="Department"
                      data={departments}
                      value={values.departmentId}
                      onChange={({ value, text }) => {
                        setFieldTouched('departmentId', false);
                        setFieldValue('departmentId', value);
                      }}
                      valueKey="id"
                      nameKey="name"
                      invalid={touched.departmentId}
                      error={errors.departmentId}
                    /> */}
                  </div>
                  <div className="col">
                    <ReactSelect
                      containerStyle={{ height: 90 }}
                      label="Role"
                      isClearable={false}
                      options={roles}
                      value={values.roleNames}
                      onChange={({ value }) => {
                        setFieldTouched('roleNames', false);
                        setFieldValue('roleNames', value);
                      }}
                      valueKey="name"
                      labelKey="name"
                      getOptionLabel={(obj) => (
                        <div>
                          <p style={{ marginTop: 0, marginBottom: '0.5rem' }}>
                            {obj.label}
                          </p>
                          <p
                            style={{
                              marginTop: 0,
                              marginBottom: '0.5rem',
                              fontSize: '0.75rem',
                              fontStyle: 'italic',
                            }}
                          >
                            {obj.id}
                          </p>
                        </div>
                      )}
                      invalid={errors.roleNames && touched.roleNames}
                      error={errors.roleNames}
                    />
                    {/* <Dropdown
                      type="dynamic"
                      required
                      className="w-100"
                      label="Role"
                      data={roles}
                      value={values.roleNames}
                      onChange={({ value, text }) => {
                        setFieldTouched('roleNames', false);
                        setFieldValue('roleNames', value);
                      }}
                      valueKey="name"
                      nameKey="name"
                      subtitleKey="id"
                      invalid={touched.roleNames}
                      error={errors.roleNames}
                    /> */}
                    <FormGroup>
                      <Label>
                        {t('Groups')} <Required />
                      </Label>
                      <div>
                        {groups.map((group) => (
                          <CustomInput
                            key={group.id}
                            type="checkbox"
                            id={group.id}
                            label={`(${group.departmentName}) ${group.name}`}
                            checked={
                              values.groupIdArray &&
                              values.groupIdArray.includes(group.id)
                            }
                            onChange={(e) =>
                              selectGroup(
                                e,
                                group,
                                values.groupIdArray,
                                setFieldValue,
                              )
                            }
                          />
                        ))}
                      </div>
                      {touched.groupIdArray && errors.groupIdArray && (
                        <FormFeedback>{t(errors.groupIdArray)}</FormFeedback>
                      )}
                    </FormGroup>
                  </div>
                </div>
                <Alert.Error text={props.errors} />
                <Button
                  id="edit-user-config"
                  loading={isSubmitting}
                  onClick={(e) => {
                    e.preventDefault();
                    handleSubmit();
                  }}
                  // disabled={props.isEditable}
                >
                  <i className="md-icon">done</i>
                  {t('Save')}
                </Button>
              </Form>
            );
          }}
        </Formik>
      </div>
    </Backend>
  );
};

export default withTranslation('app')(EditUserPage);
